import conf from '../config';

const initialState = {
  history: {},
};

const SET_HISTORY = 'SET_HISTORY';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORY:
      const hisotry = Object.assign({}, state.hisotry, {
        [action.payload._id]: action.payload,
      });
      return { ...state, hisotry };
    default:
      return state;
  }
};

const setHistory = history => ({ type: SET_HISTORY, payload: history });

export const getHistory = (id, catogary, forceFetch) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const history = state.history.history;
  if (history[id] && !forceFetch) return history[id];
  const request = await fetch(`${conf.apiRoot}/api/${catogary}/${id}/history`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (request) dispatch(setHistory({ id: history }));
  return request;
};



// WEBPACK FOOTER //
// ./src/modules/history.js